import React, { Component } from 'react';
import { Menu, Dropdown, Icon, message } from 'antd';

const msglist = [1,2,3,4,5,6]
const itemStyle = {
  width: '200px',
  height: '40px',
  lineHeight: '40px',
  boxSizing: 'border-box',
  padding: '0 10px',
  display: 'flex',
  justifyContent: 'space-between',
  fontSize:'12px',
  // borderBottom: '1px solid '
}
const menu = (
  <Menu >
    {
      msglist.map(el=>{
        return (
          <Menu.Item key={el}>
            <div style={itemStyle}>
              <div>消息的title。。</div>
              <div>2022-12-23</div>
            </div>
          </Menu.Item>
        )
      })
    }
  </Menu>
)

export default class MsgList extends Component {
  render() {
    return (
        <Dropdown overlay={menu} placement="bottomCenter">
          <div className={this.props.className}>
            <Icon type="smile" />
          </div>
        </Dropdown>
    )
  }
}



// WEBPACK FOOTER //
// ./apps/pages/main/layout/operation/MsgList/index.js